
<div class="col-lg-12 col-md-12 col-sm-12 padding0px" style="padding-left: 2px;border-top: groove;border-top-color: #4f87f6;">
  <div class="col-lg-6 col-md-6 col-sm-6">
    <div *ngFor="let item of __oFAScoringModelFinalScoreView; let i= index">
      <div class="dx-field" *ngIf="item.DataType =='Dropdown'" style="padding-top:5px;padding-left:2px;">
        <div class="dx-field-label" title="{{item.RatingCategoryAlias}}">
          {{item.RatingCategoryAlias}}
        </div>
        <div class="dx-field-value">
          <dx-select-box 
                         [dataSource]="item.JSONItemSource"
                         displayExpr="DisplayMember"
                         valueExpr="DisplayMember"
                         [(value)]="item.DataValue"
                         [readOnly]="item.IsReadOnly || __bReadOnly == 1"
                         [searchEnabled]="true">
          </dx-select-box>          
        </div>
      </div>
      <div class="dx-field" *ngIf="item.DataType =='Alpha Numeric'" style="padding-top:5px;padding-left:2px;">
        <div class="dx-field-label" title="{{item.RatingCategoryAlias}}">{{item.RatingCategoryAlias}}</div>
        <div class="dx-field-value">
          <dx-text-area  [readOnly]="item.IsReadOnly || __bReadOnly == 1"  [(value)]="item.DataValue" ></dx-text-area>         
        </div>
      </div>
      <div class="dx-field" *ngIf="item.DataType =='Numeric/Money'" style="padding-top:5px;padding-left:2px;">
        <div class="dx-field-label" title="{{item.RatingCategoryAlias}}">{{item.RatingCategoryAlias}}</div>
        <div class="dx-field-value">
          <dx-number-box [step]="0" [(value)]="item.DataValue" format="#,##0.00" (onKeyUp)="onKeyPressNumberBox($event,item)" [disabled]="item.IsReadOnly || __bReadOnly == 1" style="text-align:right;"></dx-number-box>          
        </div>
      </div>
    </div>
  </div>
</div>

<div class="col-lg-12 col-md-12 col-sm-12 padding0px" style="padding-left: 2px;">  
    <div *ngFor="let item of __oFAScoringModelFinalScoreView;">      
      <div class="dx-field" *ngIf="item.DataType =='Rich Text Box' && (item.IsReadOnly == 0 && __bReadOnly == 0)" style="padding-top:5px;padding-left:15px;">
        <div class="dx-field-label" title="{{item.RatingCategoryAlias}}" style="width: 17%; ">
          {{item.RatingCategoryAlias}}
        </div>
        <div class="dx-field-value" style="width: 80.5%; ">
          <div [froalaEditor]="__oFroalaEditorOptions" [(froalaModel)]="item.DataValue"></div>
        </div>
      </div>
      <div class="dx-field" *ngIf="item.DataType =='Rich Text Box' &&  (item.IsReadOnly == 1 || __bReadOnly == 1)" style="padding-top:5px;padding-left:15px;">
        <div class="dx-field-label" title="{{item.RatingCategoryAlias}}" style="width: 17%; ">
          {{item.RatingCategoryAlias}}
        </div>
        <div class="dx-field-value" style="width: 80.5%; ">
          <div [froalaEditor]="__oFroalaEditorOptionReadOnly" [(froalaModel)]="item.DataValue"></div>
        </div>
      </div>
    </div> 
</div>

  <dx-load-panel id="pnlLoad"
                 shadingColor="rgba(0,0,0,0.4)"
                 [position]="{ at: 'center' }"
                 [(visible)]="__bIsLoadingVisible"
                 [showIndicator]="true"
                 [showPane]="true"
                 [shading]="true"
                 [hideOnOutsideClick]="false"
                 [height]="75"
                 [width]="150"
                 message="Please Wait...">
  </dx-load-panel>
